module.exports = __webpack_public_path__ + "img/aplus.3d105f26.png";